import { render } from "./PainelLoginTipoA.vue?vue&type=template&id=43c7f0f0&scoped=true"
import script from "./PainelLoginTipoA.vue?vue&type=script&lang=js"
export * from "./PainelLoginTipoA.vue?vue&type=script&lang=js"

import "./PainelLoginTipoA.vue?vue&type=style&index=0&id=43c7f0f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c7f0f0"]])

export default __exports__